/**
 * Routine Builder — goal card selection + CTA query param
 */
(() => {
  const ROOT = '[data-ct-rb]';

  /** @param {HTMLElement} root */
  const init = (root) => {
    if (root.dataset.ctRbReady === 'true') return;
    root.dataset.ctRbReady = 'true';

    const cards = /** @type {NodeListOf<HTMLElement>} */ (
      root.querySelectorAll('[data-ct-rb-card]')
    );
    const cta = /** @type {HTMLAnchorElement | null} */ (
      root.querySelector('[data-ct-rb-cta]')
    );
    if (!cards.length) return;

    const baseHref = cta ? cta.getAttribute('href') || '/' : '/';

    /** @param {string} goal */
    const syncCta = (goal) => {
      if (!cta) return;
      try {
        const url = new URL(baseHref, window.location.origin);
        if (goal) url.searchParams.set('goal', goal);
        else url.searchParams.delete('goal');
        cta.href = url.pathname + url.search + url.hash;
      } catch {
        cta.href = goal ? `${baseHref}${baseHref.includes('?') ? '&' : '?'}goal=${encodeURIComponent(goal)}` : baseHref;
      }
    };

    /** @param {HTMLElement} card */
    const select = (card) => {
      cards.forEach((el) => {
        const on = el === card;
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      syncCta(card.dataset.goal || '');
    };

    cards.forEach((card) => {
      card.addEventListener('click', () => select(card));
      card.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          select(card);
        }
      });
    });

    const active = root.querySelector('[data-ct-rb-card].is-active, [data-ct-rb-card][aria-selected="true"]');
    if (active instanceof HTMLElement) syncCta(active.dataset.goal || '');
  };

  const boot = () => {
    document.querySelectorAll(ROOT).forEach((el) => {
      if (el instanceof HTMLElement) init(el);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
